import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getBudgetSelectors } from 'src/app/modules/collect-data/components/budget/store/budget.selectors';
import { IBudgetState } from 'src/app/modules/collect-data/components/budget/store/budget.state';
import { IWorkProposals } from 'src/app/modules/interfaces/work-proposals.interface';
import { setSettingsAction } from 'src/app/modules/settings/store/settings.actions';
import { getSettingsSelectors } from 'src/app/modules/settings/store/settings.selectors';
import { ISettingsState } from 'src/app/modules/settings/store/settings.state';
import { WorkProposalsService } from 'src/app/services/work-proposals.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-financial-consultancy',
  templateUrl: './financial-consultancy.component.html',
  styleUrls: ['./financial-consultancy.component.scss'],
})
export class FinancialConsultancyComponent implements OnInit {
  formsId: number;
  workProposalData: IWorkProposals = {
    id: 0,
    consultant_project_value: 0,
    followup_service: 0,
    default_pricing: 1,
    discount: 0,
    hide_deliverables: 0,
    installment: 0,
    rba_percentual: 0,
    type_of_investments_id: 0,
    type_of_payments_id: 0,
  };

  dataBudgetState$: Observable<IBudgetState>;
  dataBudgetState: IBudgetState;

  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingsState;

  isCreditCardSelected: boolean = false;
  isInCashSelected: boolean = false;

  financialConsultantValueBr: string = '';
  financialConsultantValueWithDiscountBr: string = '';

  financialConsultantInstallmentValueBr: string = '';

  constructor(
    private store: Store,
    private workProposalsService: WorkProposalsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getBudgetState();
    this.getState();
    this.processingData();
  }

  loadWorkProposalsData() {
    this.workProposalsService.getWorkProposalsData(this.formsId)
      .subscribe((response) => {
        this.workProposalData = response;
        if (
          response.type_of_payments_id === 2 &&
          response.type_of_investments_id === 1
        ) {
          this.isInCashSelected = true;
          this.isCreditCardSelected = false;
          this.dataStoreSetting.jobOfferCardSelect = 'financial consultant in cash';
        } else if (
          response.type_of_payments_id === 1 &&
          response.type_of_investments_id === 1
        ) {
          this.isCreditCardSelected = true;
          this.isInCashSelected = false;
          this.dataStoreSetting.jobOfferCardSelect =
            'financial consultant credit card';
        } else {
          this.isCreditCardSelected = false;
          this.isInCashSelected = false;
        }
        
        this.setState({ ...this.dataStoreSetting });
      });
  }

  async processingData() {
    await this.validateFinancialConsultantValue();

    this.financialConsultantValueBr = this.formatToBRL(
      this.dataStoreSetting.financialConsultantValue
    );

    this.financialConsultantValueWithDiscountBr = this.formatToBRL(
      this.dataStoreSetting.financialConsultantValueWithDiscount
    );

    this.financialConsultantInstallmentValueBr = this.formatToBRL(
      this.dataStoreSetting.installmentFinancialConsultantValue
    );
  }

  getState(): void {
    this.dataStoreSetting$ = this.store.select(getSettingsSelectors);
    this.dataStoreSetting$.subscribe((value) => {
      this.dataStoreSetting = {
        ...value,
      };
      if ( this.dataStoreSetting.jobOfferCardSelect == 'advisor in cash' || this.dataStoreSetting.jobOfferCardSelect == 'advisor credit card' ) {
        this.isInCashSelected = false;
          this.isCreditCardSelected = false;
      }
    });
    this.loadWorkProposalsData();
  }

  getBudgetState() {
    this.dataBudgetState$ = this.store.select(getBudgetSelectors);
    this.dataBudgetState$.subscribe((value) => {
      this.dataBudgetState = { ...value };
    });
  }

  setState(data: ISettingsState): void {
    this.store.dispatch(setSettingsAction(data));
  }

  validateFinancialConsultantValue(): void {
    let annualRecipeValue = this.dataBudgetState.annualRecipe;
    let totalValue =
      annualRecipeValue * (this.dataStoreSetting.percentValue / 100);

    if (totalValue > this.dataStoreSetting.manualValue) {
      this.dataStoreSetting.financialConsultantValue = totalValue;
    } else {
      this.dataStoreSetting.financialConsultantValue =
        this.dataStoreSetting.manualValue;
    }

    this.updateCreditCardValues();
    this.updateInCashValues();
  }

  updateCreditCardValues(): void {
    this.dataStoreSetting.installmentFinancialConsultantValue =
      this.dataStoreSetting.financialConsultantValue /
      this.dataStoreSetting.installments;
    this.dataStoreSetting.installmentAdvisorValue =
      this.dataStoreSetting.advisorValue / this.dataStoreSetting.installments;
  }

  updateInCashValues(): void {
    this.dataStoreSetting.financialConsultantValueWithDiscount =
      this.applyingDiscountPercentage(
        this.dataStoreSetting.percentualDiscount,
        this.dataStoreSetting.financialConsultantValue
      );
    this.dataStoreSetting.advisorValueWithDiscount =
      this.applyingDiscountPercentage(
        this.dataStoreSetting.percentualDiscount,
        this.dataStoreSetting.advisorValue
      );
  }

  applyingDiscountPercentage(percentage: number, value: number): number {
    if (percentage < 0 || percentage > 100) {
      return value;
    }
    if (value < 0) {
      return value;
    }
    const discount = (percentage / 100) * value;
    const discountedValue = value - discount;
    return discountedValue;
  }

  creditCardSelected(event: any) {

    this.isInCashSelected = false;

    if (this.isCreditCardSelected) {
      this.dataStoreSetting.jobOfferCardSelect = 'financial consultant credit card';
    } else { this.dataStoreSetting.jobOfferCardSelect = ''}
    
    this.setState(this.dataStoreSetting);

    const updateData: Partial<IWorkProposals> = {
      type_of_payments_id: 1,
      type_of_investments_id: 1,
    };
    this.workProposalsService.updateWorkProposalsData(
        this.formsId,
        this.workProposalData.id,
        updateData
      ).subscribe();
  }

  inCashSelected(event: any) {
    this.isCreditCardSelected = false;
    if (this.isInCashSelected) {
      this.dataStoreSetting.jobOfferCardSelect = 'financial consultant in cash';
     
    } else {
      this.dataStoreSetting.jobOfferCardSelect = '';
    }
    this.setState(this.dataStoreSetting);

    const updateData: Partial<IWorkProposals> = {
      type_of_payments_id: 2,
      type_of_investments_id: 1
    }
    this.workProposalsService.updateWorkProposalsData(this.formsId, this.workProposalData.id, updateData).subscribe()
  }

  formatToBRL(value: number): string {
    if (isNaN(value)) {
      value = 0;
    }

    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }
}
